import { Interlocuteur } from './Interlocuteur';

export class ContactDTO {
    interlocuteur: Interlocuteur;
    objet: string;
    description: string;

    constructor(interlocuteur: Interlocuteur, objet: string, description: string){
        this.interlocuteur = interlocuteur;
        this.objet = objet;
        this.description = description;
    }
}
